var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#ffab00",
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.69 16.55a5.69 5.69 0 1 1 -5.69 5.69 5.69 5.69 0 0 1 5.69-5.69zm18.62 0a5.69 5.69 0 1 1 -5.68 5.69 5.67 5.67 0 0 1 5.66-5.69zm-18.62 5.69 5.12-6.55 9.41-1m1.57-2.65-2.65.18 5.16 10m-16.04-9.22h3.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.62bfb122da652b3b2600ee092b81b8c5.svg";
export { ForwardRef as ReactComponent };